// 3rd party imports
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { observer } from 'mobx-react';

// shared-ui
import { LocalizedText } from '@shared-ui/localization-context';

// mobx
import { Program } from 'src/models';

// ui
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';

import { RouteComponentProps } from 'react-router';
import { useStores } from 'hooks';

export interface IEntityTermsAndConditionsProps extends RouteComponentProps {
  program?: Program;
}

export const EntityTermsAndConditions: React.FunctionComponent<IEntityTermsAndConditionsProps> = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function EntityTermsAndConditions({ program }) {
    const { context, pzCampaignStore, legal } = useStores();
    const { useEffect, useState } = React;

    const [terms, setTerms] = useState('');

    const fetchCampaign = async () => {
      const pzLocale = program.pzLocale || program.locale.toLowerCase();

      await pzCampaignStore.fetchCampaign(program.name, context.locale, pzLocale);

      const entityTc = pzCampaignStore.campaignTerms;
      setTerms(entityTc);
    };

    useEffect(() => {
      fetchCampaign();
    }, []);

    return (
      <UitkSpacing className="container--small" padding={{ block: 'twelve' }}>
        <main>
          <UitkHeading tag="h1" size={3}>
            <LocalizedText message="pz.signup.form.label.program_terms" data={[program.title]} />
          </UitkHeading>
          <UitkSpacing margin={{ block: 'three' }}>
            <div dangerouslySetInnerHTML={{ __html: terms }} />
          </UitkSpacing>
        </main>
      </UitkSpacing>
    );
  },
);

export const TcWithRouter = withRouter(EntityTermsAndConditions);
